import { HTTP } from 'providers'

export class IndustryGroupProfileService extends HTTP {
  private endpoint = '/company-group-profile'

  public fetchAll(params = {}) {
    return this.get({ endpoint: this.endpoint, params })
  }
}
